import {
  actions,
  getSystemConfigsDataTableAsync,
  getSystemConfigByIdAsync,
  editSystemConfigAsync,
} from './slices';

export const SystemConfigsActions = {
  ...actions,
  getSystemConfigsDataTableAsync,
  getSystemConfigByIdAsync,
  editSystemConfigAsync,
};
